import { ComingSoonEmptyState } from '../../shell/empty-states/coming-soon-empty-state.js';

export function GameSettingsNotificationsPage(): JSX.Element {
  return (
    <ComingSoonEmptyState
      title="Notifications"
      description="Configure game-level notification preferences. Lands with the Notifications story."
    />
  );
}
